import React, { FunctionComponent } from 'react';
import { APIReference_apiReference_ClassReference_codeSample as ClassReferenceCodeSamples } from '@modules/client';
import CodeSamples from '@modules/ui/shared/components/CodeSamples';
import AlertMarkdown from '@modules/ui/shared/components/AlertMarkdown';
import StandardMarkdown from '@modules/ui/markdown/components/StandardMarkdown';
import EngineMarkdown from '@modules/ui/markdown/components/EngineMarkdown';
import { useTranslation } from '@rbx/intl';
import { TCompileTree } from '@modules/markdownProcessor/markdownProcessor';
import { Grid } from '@rbx/ui';
import { EngineTag } from '@modules/ui/tags/types';
import useReferenceDescriptionStyles from './ReferenceDescription.styles';
import ReferenceCodeSamples from './ReferenceCodeSamples';
import ReferenceMemberTags from './ReferenceMemberTags';

export interface APIReferenceDescriptionProps {
  name: string;
  tags?: EngineTag[] | null;
  description?: string | TCompileTree | null;
  deprecationMessage?: string | null;
  codeSamples?: ClassReferenceCodeSamples[] | null;
  engineRevampEnabled?: boolean;
}

const APIReferenceDescription: FunctionComponent<
  React.PropsWithChildren<APIReferenceDescriptionProps>
> = ({ name, tags, description, deprecationMessage, codeSamples, engineRevampEnabled = false }) => {
  const { translate } = useTranslation();
  const {
    classes: { boxBottomSpacing },
  } = useReferenceDescriptionStyles();
  if (engineRevampEnabled) {
    return (
      <div>
        <EngineMarkdown>{description}</EngineMarkdown>
        {Array.isArray(codeSamples) && codeSamples.length > 0 && (
          <ReferenceCodeSamples codeSamples={codeSamples} />
        )}
      </div>
    );
  }

  return (
    <div>
      {tags && (
        <Grid container marginTop={1.5} marginBottom={2}>
          <Grid item>
            <ReferenceMemberTags tags={tags} memberName={name} />
          </Grid>
        </Grid>
      )}
      {deprecationMessage && (
        <div className={boxBottomSpacing}>
          <AlertMarkdown title={translate('Label.Deprecated') || 'Deprecated'}>
            {deprecationMessage}
          </AlertMarkdown>
        </div>
      )}
      <div>
        <StandardMarkdown>{description}</StandardMarkdown>
        {Array.isArray(codeSamples) && codeSamples.length > 0 ? (
          <CodeSamples codeSamples={codeSamples} />
        ) : null}
      </div>
    </div>
  );
};

export default APIReferenceDescription;
